import React, { useEffect } from "react";
import { FilterModalSelect } from "./FilterModalSelect";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllIssueTypes } from "../../../../../store/actions/formOptions";

export const IssueTypeFilter = ({ issueType, setSelectedIssueType }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAllIssueTypes());
  }, [dispatch]);

  const issueTypes = useSelector((state) => state.formOptions.types || []);

  return (
    <FilterModalSelect
      label="Issue Type"
      value={issueType}
      onChange={setSelectedIssueType}
      placeholderText="Select Issue Type"
      options={issueTypes}
    />
  );
};
